import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBenefitOfSupplies } from "../../actions/MyPlan";
import { deviceWithDCP, deviceWithHL, deviceWithMFC } from "../../constants/BenefitOfSupplyConstant";
import { READY_PROMOTION } from "../../constants/AppConstants";
import currencies from "../../constants/CurrencyTypes";
import { ENVSettings, EXTERNAL_LINK_ENDPOINT } from "../../constants/ENVSettings";
import { formatNumberOnLocale } from "../../constants/AppMethod";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { nativeAppRoutePaths } from "../../constants/Routes";

const UseGetPlanDetailsBenefitOfSuppliesPage = (props) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const { printerModel, countryCode, languageCode } = props;
    const planResult = useSelector(state => state.GetBenefitOfSupplies);
    const [trialmonths, setTrialmonths] = useState("")
    const [planCurrency, setPlanCurrency] = useState("")
    const [planPrice, setPlanPrice] = useState("")
    const [marketingUrl, setMarketingUrl] = useState("")

    const fetchOnlyPrinterModelFromUrl = (printerModel) => {
        // split sentence into an array of words
        const words = printerModel?.split(" ");
        // filter words that contain "MFC", "DCP","HL"
        const filteredWords = words?.filter(word => word.includes(deviceWithMFC) || word.includes(deviceWithDCP) || word.includes(deviceWithHL)); 
        const extractedModel = filteredWords[0]; 
        return extractedModel
    }

    const getPlanTranslation = (toBeTranslatedData) => {
          if(toBeTranslatedData === "XmonthsFreePromotion"){
            return "2"
          }
          else if(toBeTranslatedData === "ReadyPromotion"){
            return "4"
          }
    } 
    
    const findPromotionTypeBenefitOfSupplies = (discounts) => {
        let promotion = ""
        for (let i = 0; i < discounts.length; i++) {
            if(discounts[i].planName === READY_PROMOTION.discountName){
            promotion = getPlanTranslation(discounts[i].planName)
            break;
            }
            promotion = getPlanTranslation(discounts[i].planName)
        }
        return promotion
    }

    useEffect(() => {
        const isNotBplus = (location.pathname.indexOf(nativeAppRoutePaths.BPLUS.BENEFIT_PAGE) === -1) ? true : false
        if(isNotBplus){
            const extractedModel = printerModel ? fetchOnlyPrinterModelFromUrl(printerModel):""
            if(extractedModel){
                const promotion = (extractedModel[extractedModel.length - 1] === "E") ? READY_PROMOTION.promotion : undefined;
                dispatch(getBenefitOfSupplies(extractedModel, promotion));
            }
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(()=>{
      let plansList;
      let least_plan_price;
      let planCurrency;
      if(planResult.success ){
          if(planResult.hasOwnProperty("plans") 
          &&  planResult.plans.plans.length > 0 
          ){
              plansList =  planResult.hasOwnProperty("plans")
              && planResult.plans.plans.length > 0  
                  ? planResult.plans.plans : null
              plansList && plansList
                ?.map((plan) => {
                  if(plan.discount && plan?.discount?.length > 0){
                      setTrialmonths(findPromotionTypeBenefitOfSupplies(plan.discount))
                      planCurrency = currencies[plan.currency]?.code
                      setPlanCurrency(currencies[plan.currency]?.code)
                  }
                  return plan
              })
              least_plan_price = Math.min(
                  ...plansList.filter(element => element.planName !== 'PowerUser').map((element) => {
                        return element?.price;
                  })
              );
              setPlanPrice(formatNumberOnLocale(least_plan_price, currencies[planCurrency]?.code, `${languageCode}-${countryCode}`))
              
              const baseurl = ENVSettings.MAIN_BASE_URL;
              let marketingUrl;
              if(languageCode.toLowerCase() === "fr"){
                  marketingUrl = `${baseurl}${EXTERNAL_LINK_ENDPOINT.FrenchMarketingPage}`
              }
              else{
                  marketingUrl = `${baseurl}${EXTERNAL_LINK_ENDPOINT.marketingPage}`
              }        
              setMarketingUrl(marketingUrl)
          }
      }
      //eslint-disable-next-line react-hooks/exhaustive-deps
  },[planResult,countryCode])

  return {
    trialmonths,
    planCurrency,
    planPrice,
    marketingUrl,
    planResult
  }
}

export default UseGetPlanDetailsBenefitOfSuppliesPage;